export const GET_VOLUME_CONTRACTS = 'GET_VOLUME_CONTRACTS';
export const GET_VOLUME_CONTRACTS_RESPONSE = 'GET_VOLUME_CONTRACTS_RESPONSE';
export const GET_VOLUME_CONTRACTS_ERROR = 'GET_VOLUME_CONTRACTS_ERROR';

export const REGISTER_PRODUCT_BY_VOLUME = 'REGISTER_PRODUCT_BY_VOLUME';
export const REGISTER_PRODUCT_BY_VOLUME_RESPONSE = 'REGISTER_PRODUCT_BY_VOLUME_RESPONSE';
export const REGISTER_PRODUCT_BY_VOLUME_ERROR = 'REGISTER_PRODUCT_BY_VOLUME_ERROR';
export const CLEAR_VOLUME_REGISTRATION_UI = 'CLEAR_VOLUME_REGISTRATION_UI';
export const CLEAR_VOLUME_REGISTRATION_ERROR = 'CLEAR_VOLUME_REGISTRATION_ERROR';

const volume = {
    // fetch list of volume contracts
    getVolumeContracts: () => ({ type: GET_VOLUME_CONTRACTS }),
    getVolumeContractsResponse: (response) => ({
        type: GET_VOLUME_CONTRACTS_RESPONSE,
        response,
    }),
    getVolumeContractsError: (error) => ({
        type: GET_VOLUME_CONTRACTS_ERROR,
        error,
    }),

    // submit one (or many) products under volume registration
    registerProductByVolume: (os, contractId, traces, successCallback) => ({
        type: REGISTER_PRODUCT_BY_VOLUME,
        os,
        contractId,
        traces,
        successCallback,
    }),
    registerProductByVolumeResponse: (response) => ({
        type: REGISTER_PRODUCT_BY_VOLUME_RESPONSE,
        response,
    }),
    registerProductByVolumeError: (error) => ({
        type: REGISTER_PRODUCT_BY_VOLUME_ERROR,
        error,
    }),
    clearVolumeRegistrationUI: () => ({
        type: CLEAR_VOLUME_REGISTRATION_UI,
    }),
    clearVolumeRegistrationError: () => ({
        type: CLEAR_VOLUME_REGISTRATION_ERROR,
    }),
};

export default volume;
